<template>
    <div id="six" ref="observerEle" class="mb-5 ratingBox">
        <div class="type-line mb-5">
            <h4 class="type-title">評價</h4>
            <div class="evaluation-line">
                <span class="star-icon"><img src="img/pic/star.png" alt="icon" ></span>
                <span>{{ scope }}</span>
                <span> ( {{ ratingCount }} )</span>
            </div>
        </div>
        <div v-if="isLoading" class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>

        <template v-if="!userHasRating">
            <span class="prompt-line">您似乎還沒有評價，和大家分享的心得吧。
                <div v-if="authCheck" class="prompt-item rating" @click="formToggle">填寫新評價</div>
                <a v-else href="user/login" class="promptLoginBtn">請先登入會員</a>
            </span>
            <form :action="pageType+'/rating'" method="post">
                <div class="rating-form" v-show="formActive">
                    <p>評價</p>
                    <rating-component></rating-component>
                    <p>評價內容</p>
                    <textarea name="ratingContent"></textarea>
                    <input-upload-pic
                        :inputName="'picIds'"
                        :postMaxSize="postMaxSize"
                        :uploadMaxSize="uploadMaxSize"
                        :maxFileUploads="maxFileUploads"
                    ></input-upload-pic>
                    <button class="rating-btn" type="submit">送出評價</button>
                </div>
                <input type="hidden" name="pageSlug" :value="slug">
                <input type="hidden" :name="pageType+'Id'" :value="id">
            </form>
        </template>
        <rating-search
            :slug="slug"
            :page="page"
            :pageKey="'page'"
            :filterFieldsVisible="['ratingStart', 'hasPic', 'sort', 'purchaseVerify']"
            :page-type="pageType"
            :urlKey="urlKey"
        ></rating-search>
        <template v-if="ratings.length == 0">
            <p v-show="!isLoading" class="rating-empty">目前還沒有任何評價</p>
        </template>
        <template v-else>
            <rating v-for="rating in ratings" :key="rating.id"
                    :currentUserId="authId"
                    :rating="rating"
                    :userName="rating?.User?.name"
                    :userPicUrl="rating?.User?.picUrl"
                    :authCheck="authCheck"
                    :userCheckPurview="userCheckPurview && !rating?.Replies[0]"
                    :hiddenDislikeRattingCount="hiddenDislikeRattingCount"
                    :replyPicUrl="replyPicUrl"
                    :postMaxSize="postMaxSize"
                    :uploadMaxSize="uploadMaxSize"
                    :maxFileUploads="maxFileUploads"
                    :pageSlug="slug"
                    :likePostUrl="pageType+'/rating/toggleLike'"
                    :ratingPostUrl="pageType+'/rating/reply'"
            ></rating>
            <!-- 分頁按鈕 -->
            <div v-if="ratings" class="pagination">
                <span :class="{active: ratingsPaginate.currentPage === 1, disabled: isLoading}"
                      @click="setPage(1)">1</span>
                <span v-if="ratingsPaginate.currentPage > 3"
                      :class="{disabled: isLoading}">...</span>
                <span v-for="page in surroundingPages"
                      :class="{active: ratingsPaginate.currentPage === page, disabled: isLoading}"
                      @click="setPage(page)">{{ page }}</span>

                <span v-if="ratingsPaginate.currentPage < ratingsPaginate.last_page - 3"
                      :class="{disabled: isLoading}">...</span>
                <span v-if="ratingsPaginate.last_page > 1"
                      :class="{active: ratingsPaginate.currentPage === ratingsPaginate.last_page, disabled: isLoading}"
                      @click="setPage(ratingsPaginate.last_page)">{{ ratingsPaginate.last_page }}</span>
            </div>
        </template>
    </div>
</template>
<script>
import Rating from 'Vue/Web/Common/Rating/Rating.vue';
import RatingComponent from 'Vue/Web/Plugins/RatingComponent.vue';
import RatingSearch from 'Vue/Web/Common/Rating/RatingSearch.vue';
import InputUploadPic from 'FF/Vue/ControlCenter/CustomComponent/EditControlCenter/LineContent/Base/InputUploadPic.vue';

export default {
    name: 'SectionRatingComponent',
    components: {
        Rating,
        RatingComponent,
        RatingSearch,
        InputUploadPic,
    },
    props: {
        id: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        authId: {
            type: Number,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: -1,
        },
        userCheckPurview: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
        slug: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        authCheck: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
        postMaxSize: {
            type: Number,
            default: 0,
        },
        uploadMaxSize: {
            type: Number,
            default: 0,
        },
        maxFileUploads: {
            type: Number,
            default: 0,
        },
        userHasRating: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
        hiddenDislikeRattingCount: {
            type: Number,
            default: 0,
        },
        replyPicUrl: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '/api/courseRating',
        },
        pageType: {
            type: String,
            default: 'course',
        },
    },
    data() {
        return {
            isLoading: true,
            ratings: [],
            ratingsPaginate: {},
            formActive: false,
            scope: 0,
            ratingCount: 0,
            page: '1',
            ratingStart: '',
            hasPic: '',
            sort: 'new',
            purchaseVerify: '',
            urlKey: 'ratingBox',
        };
    },
    computed: {
        // 根據總頁數產生頁碼數組
        surroundingPages() {
            const pages = [];
            const currentPage = this.ratingsPaginate.current_page;
            const lastPage = this.ratingsPaginate.last_page;
            const start = Math.max(2, currentPage - 2);
            const end = Math.min(lastPage - 1, currentPage + 2);

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        },
    },
    mounted() {
        this.setupIntersectionObserver();
        const queryParams = new URLSearchParams(window.location.search);
        this.page = queryParams.get('page') || '1';
        this.ratingStart = queryParams.get('ratingStart') || '';
        this.hasPic = queryParams.get('hasPic') || '';
        this.sort = queryParams.get('sort') || 'new';
        this.purchaseVerify = queryParams.get('purchaseVerify') || '';
    },
    methods: {
        formToggle() {
            this.formActive = !this.formActive;
        },
        formatDate(dateString) {
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 10% 的範圍時觸發
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && this.id) {
                        this.getResult();
                        observer.unobserve(this.$refs.observerEle); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);

            if (this.$refs.observerEle) {
                observer.observe(this.$refs.observerEle);
            }
        },
        async getResult() {
            const params = {
                page: this.page,
                ratingStart: this.ratingStart,
                hasPic: this.hasPic,
                sort: this.sort,
                purchaseVerify: this.purchaseVerify,
                scrollTo: 1,
            };

            const filteredParams = Object.fromEntries(
                // eslint-disable-next-line no-unused-vars
                Object.entries(params)
                    .filter(([key, value]) => value !== null && value !== ''),
            );

            try {
                const vueThis = this;
                await axios.post(`${this.url}/${this.id}`, filteredParams)
                    .then((response) => {
                        vueThis.ratings = response?.data?.Ratings?.data ?? [];
                        vueThis.ratingsPaginate = response?.data?.Ratings ?? [];
                        vueThis.scope = response?.data?.scope ?? 0;
                        vueThis.ratingCount = response?.data?.Ratings.total ?? 0;
                        vueThis.isLoading = false;
                    });

                // 等待 DOM 完全更新後再初始化 OwlCarousel
                this.$nextTick(() => {
                    // this.initOwlCarousel();
                });
            } catch (error) {
                console.log(error);
            }
        },
        setPage(page) {
            if (!page) return;
            // 將 first_page_url 作為基礎 URL
            // const pageUrl = new URL(this.ratingsPaginate.first_page_url);
            const pageUrl = new URL(window.location.href);
            // 替換 page 參數
            pageUrl.searchParams.set('page', page);

            // 跳轉到新的 URL
            window.location.href = pageUrl.toString();
        },
    },
};
</script>
<style scoped lang="scss">
$maincolor: #72ca4a;
.spinner-border {
    margin: 50px 50%;
}

.ratingBox {
    margin-bottom: 50px;
    word-wrap: break-word;
    font-size: 14px;
    color: #666;
    .type-line {
        display: flex;
        align-items: center;
        .type-title {
            flex: 1;
            color: #72ca4a;
            font-size: 18px;
            margin-bottom: 0;
        }
        .evaluation-line {
            color: #555;
            flex: 1;
            text-align: right;
            .star-icon {
                display: inline-block;
                width: 15px;
                line-height: 13px;
                margin-right: 0.5rem;
            }
        }
    }
    .prompt-line {
        display: block;
        font-weight: 400;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 2rem;
        .prompt-item, promptLoginBtn {
            display: inline-block;
            color: #72ca4a;
            line-height: 19px;
            border-bottom: 1px solid #72ca4a;
            cursor: pointer;
            font-size: 18px;
        }
    }
    .rating-form {
        padding-bottom: 30px;
        transition: 0.5s;
        textarea {
            width: 100%;
            height: 100px;
            margin-bottom: 10px;
            line-height: 18px;
            padding: 5px;
            border: 1px solid #CCC;
            transition: border 0.5s;
            resize: vertical;
            border-radius: 5px;
        }
        .rating-btn {
            display: block;
            width: 150px;
            height: 40px;
            color: white;
            background-color: #72ca4a;
            border: none;
            border-radius: 3px;
            transition: 0.3s;
        }
    }
    .rating-empty {
        color: #666;
        font-size: 16px;
        margin: 40px 0;
    }
}
.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}

.pagination span {
    margin: 0 5px;
    padding: 5px 10px;
    cursor: pointer;
    border: 1px solid #ddd;
}

.pagination span.active {
    background-color: #72ca4a;
    color: white;
}
</style>
